var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAckoLogoHalfSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 64,
    viewBox: "0 0 87 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    stroke: "#B191ED",
    strokeOpacity: 0.2,
    strokeWidth: 1.171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 25.788v23.624c0 1.73-.78 3.224-2.354 4.258-19.721 12.92-34.654 18.352-39.877 19.861-7.206 2.084-11.024 1.864-11.644 1.82C18.97 74.4-3.47 55.513-3.47 55.513s18.362 5.188 60.137-14.698c7.832-3.728 16.573-7.751 26.738-12.464 0 0 2.594-1.27 2.594-2.569v.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 25.827c0-1.61-1.325-2.419-2.354-3.118C64.17 9.429 48.996 4.357 43.774 2.848 36.568.764 32.75.984 32.13 1.028 18.976 1.979-1.72 18.756-3.844 21.25c0 0 18.742-5.577 60.517 14.309 1.345.64 3.813 1.839 5.358 2.723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.186 54.095s-.285-.83-.465-1.555c-1.104-4.752-1.709-9.56-1.729-14.368.025-4.808.625-9.615 1.73-14.368.224-.935.35-1.32.35-1.32"
  }))));
}
export default SvgAckoLogoHalfSmall;